import { ReactNode } from 'react'

import Paper from 'shared/ui/Paper'
import Title from 'shared/ui/Title'

interface Props {
  children: ReactNode
  title: string
  className?: string
}

const UserInfoWrapper = ({ children, title, className }: Props) => {
  return (
    <Paper className={`flex-1 flex flex-col gap-[24px] p-[24px] ${className}`}>
      <Title
        level={4}
        className="!mb-0 !font-bold !leading-[28x] !text-[20px] !text-gray"
      >
        {title}
      </Title>
      {children}
    </Paper>
  )
}

export default UserInfoWrapper
